export default __webpack_public_path__ + "static/media/404-backdrop.9315fe65.png";